import { lazyLoad } from 'app/utils/loadable';

export const Requests = lazyLoad(
  () => import('./requests'),
  (module) => module.Requests
);
